export default {
  install(Vue, options) {
    const { store } = options || {};
    if (!store) {
      throw new Error('Store must be passed!');
    }

    Vue.mixin({
      methods: {
        hasFeature(feature) {
          return !!store.getters.userFeatures.find((f) => f === feature);
        },
        hasBoxFeature(deviceId, feature) {
          const features = store.getters.boxFeatures.get(deviceId);
          if (features) {
            return !!features.find((f) => f === feature);
          }
          store.dispatch('SET_BOX_FEATURE', { deviceId });
          return false;
        },
      },
    });
  },
};
